/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgWinchOut32(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={32}
      height={32}
      fill='none'
      viewBox='0 0 32 32'
      {...props}
    >
      <g fill='currentColor'>
        <path
          fillRule='evenodd'
          d='M23.25 3.25v-3h5.5v6H29A2.75 2.75 0 0131.75 9v4A2.75 2.75 0 0129 15.75h-.25v6h-5.5v-3H8.75v3h-5.5v-6H3A2.75 2.75 0 01.25 13V9A2.75 2.75 0 013 6.25h.25v-6h5.5v3h14.5zm4-1.5v18.5h-2.5V1.75h2.5zm-12 3h-2.5v12.5h2.5V4.75zm1.5 0v12.5h2.5V4.75h-2.5zm4 0v12.5h2.5V4.75h-2.5zm-12 0h2.5v12.5h-2.5V4.75zm-1.5-3h-2.5v18.5h2.5V1.75zM29 14.25h-.25v-6.5H29c.69 0 1.25.56 1.25 1.25v4c0 .69-.56 1.25-1.25 1.25zM3.25 7.75H3c-.69 0-1.25.56-1.25 1.25v4c0 .69.56 1.25 1.25 1.25h.25v-6.5z'
        />
        <path d='M15.252 20v4.01c-1.91.327-3.428 1.877-3.428 3.838 0 2.213 1.931 3.902 4.178 3.902a4.306 4.306 0 003.113-1.297.75.75 0 10-1.082-1.04 2.807 2.807 0 01-2.03.837c-1.54 0-2.68-1.133-2.68-2.401 0-1.269 1.14-2.402 2.68-2.402h.75V20h-1.5z' />
      </g>
      <defs>
        <clipPath id='winch-out-32_svg__clip0'>
          <path fill='#fff' d='M0 0h32v32H0z' />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgWinchOut32;
